import { createSelector } from 'reselect'
import _ from 'lodash'

const testConfigNamesSelector = state => state.product.fulcrumTestSuiteSelection.testConfigNames
const testListSelector = state => state.product.fulcrumTestSuiteSelection.testList
const testProfilesSelector = state => state.product.fulcrumTestSuiteSelection.testProfiles

const flattenedTestProfilesSelector = createSelector(
  testProfilesSelector,
  testProfiles => ({
    greenLightProfiles: testProfiles['greenLightProfiles'].map(profile => ({
      ...profile,
      tests: flattenTestParams(profile['tests'])
    })),
    nvqualProfiles: testProfiles['nvqualProfiles'].map(profile => ({
      ...profile,
      tests: flattenTestParams(profile['tests'])
    })),
  })
)

const flattenTestParams = (testList) => (
  testList.map(test => ({
    ...test,
    details: test['params'] && stringifyDetails(test['params'])
  }))
)

const stringifyDetails = (details) => {
  return Object.keys(details).map(key => `${key}: ${details[key]}`).join(', ')
}

const flattenedTestListSelector = createSelector(
  testListSelector,
  testList => flattenTestParams(testList)
)

export {
  testConfigNamesSelector,
  flattenedTestListSelector,
  testProfilesSelector,
  flattenedTestProfilesSelector
}